import { StatusIndicator } from '@strata/react-status-indicators';
import PropTypes from 'prop-types';

const Statuses = {
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PEND_START: 'PEND_START',
};

function getStatus(status) {
    switch (status) {
        case Statuses.ACTIVE:
            return StatusIndicator.Status.SUCCESS;
        case Statuses.PEND_START:
            return StatusIndicator.Status.IN_PROGRESS;
        default:
            return StatusIndicator.Status.DEFAULT;
    }
}

const StatusMessages = {
    [Statuses.ACTIVE]: 'Active',
    [Statuses.INACTIVE]: 'Inactive',
    [Statuses.PEND_START]: 'Pend. Start',
};

export const BackstopPharmacyStatusIndicator = ({ status }) => (
    <StatusIndicator
        status={getStatus(status)}
        message={StatusMessages[status]}
        className="font-semi-bold--uppercase"
    />
);

BackstopPharmacyStatusIndicator.propTypes = {
    status: PropTypes.oneOf(Object.values(Statuses)).isRequired,
};

BackstopPharmacyStatusIndicator.Statuses = Statuses;
BackstopPharmacyStatusIndicator.StatusMessages = StatusMessages;
